module.exports = __webpack_public_path__ + "img/green_108.53120161.png";